// TOGGLE STATE
// -----------------------------------

import $ from 'jquery';
import Storages from 'js-storage';

function initToggleState() {

    var $body = $('body');
    var toggle = new StateToggler();

    $('[data-toggle-state]')
        .on('click', function(e) {
            // e.preventDefault();
            e.stopPropagation();
            var element = $(this),
                classname = element.data('toggleState'),
                target = element.data('target'),
                noPersist = !!element.attr('data-no-persist');

            // Specify a target selector to toggle classname
            // use body by default
            var $target = target ? $(target) : $body;

            if (classname) {
                if ($target.hasClass(classname)) {
                    $target.removeClass(classname);
                    if (!noPersist)
                        toggle.removeState(classname);
                } else {
                    $target.addClass(classname);
                    if (!noPersist)
                        toggle.addState(classname);
                }

            }

            // some elements may need this when toggled class change the content size
            if (typeof(Event) === 'function') { // modern browsers
                window.dispatchEvent(new Event('resize'));
            } else { // old browsers and IE
                var resizeEvent = window.document.createEvent('UIEvents');
                resizeEvent.initUIEvent('resize', true, false, window, 0);
                window.dispatchEvent(resizeEvent);
            }
        });

}

// Handle states to/from localstorage
function StateToggler() {

    var STORAGE_KEY_NAME = 'jq-toggleState';

    /** Add a state to the browser storage to be restored later */
    this.addState = function(classname) {
        var data = Storages.localStorage.get(STORAGE_KEY_NAME);
        if (data instanceof Array) data.push(classname);
        else data = [classname];
        Storages.localStorage.set(STORAGE_KEY_NAME, data);
    };
    /** Remove a state from the browser storage */
    this.removeState = function(classname) {
        var data = Storages.localStorage.get(STORAGE_KEY_NAME);
        if (data) {
            var index = data.indexOf(classname);
            if (index !== -1) data.splice(index, 1);
            Storages.localStorage.set(STORAGE_KEY_NAME, data);
        }
    };
    /** Load the state string and restore the classlist */
    this.restoreState = function($elem) {
        var data = Storages.localStorage.get(STORAGE_KEY_NAME);
        if (data instanceof Array)
            $elem.addClass(data.join(' '));
    };
};

export { StateToggler, initToggleState };